import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumbers } = CommonParameters;

export const directDebitSetUp_KRAKEN: IMcAppType = {
  name: "directDebitSetUp_KRAKEN",
  path: "/my/direct-debit/setup",
  parameters: {
    properties: { accountNumbers },
  },
  description: "Setup Direct Debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Manage Direct debit",
  parent: Tab.MORE,

  conditions: {
    intent: "directDebitSetUp",
    customerType: CustomerType.kraken,
  },
};
